import { render } from "./contact.vue?vue&type=template&id=32627611"
import script from "./contact.js?vue&type=script&lang=js&external"
export * from "./contact.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__